export default "__VITE_ASSET__10112ccf__"